<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <div class="my-auto mb-2">
          <h2 class="mb-1">Employee</h2>
          <nav>
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <router-link to="/dashboard/"
                  ><i class="ti ti-smart-home"></i
                ></router-link>
              </li>
              <li class="breadcrumb-item">Employee</li>
              <li class="breadcrumb-item active" aria-current="page">
                Employee Grid
              </li>
            </ol>
          </nav>
        </div>

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/employee/employee-list"
                class="btn btn-icon btn-sm me-1"
              >
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link
                to="/employee/employee-grid"
                class="btn btn-icon btn-sm active bg-primary text-white"
              >
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>

          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportPDF"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="exportCSV"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_employee"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddModal"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Employee
            </a>
          </div>

          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- STATS ROW (dynamic) -->
      <div class="row">
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-dark rounded-circle"
                    ><i class="ti ti-users"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">
                    Total Employee
                  </p>
                  <h4>{{ stats.total }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-purple badge-sm fw-normal"
                  ><i class="ti ti-arrow-wave-right-down"></i
                  >{{ stats.deltaTotal }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-success rounded-circle"
                    ><i class="ti ti-user-share"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">Active</p>
                  <h4>{{ stats.active }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-primary badge-sm fw-normal"
                  ><i class="ti ti-arrow-wave-right-down"></i
                  >{{ stats.deltaActive }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-danger rounded-circle"
                    ><i class="ti ti-user-pause"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">InActive</p>
                  <h4>{{ stats.inactive }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-dark badge-sm fw-normal"
                  ><i class="ti ti-arrow-wave-right-down"></i
                  >{{ stats.deltaInactive }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <div>
                  <span class="avatar avatar-lg bg-info rounded-circle"
                    ><i class="ti ti-user-plus"></i
                  ></span>
                </div>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">New Joiners</p>
                  <h4>{{ stats.newJoiners }}</h4>
                </div>
              </div>
              <div>
                <span class="badge badge-soft-secondary badge-sm fw-normal"
                  ><i class="ti ti-arrow-wave-right-down"></i
                  >{{ stats.deltaNewJoiners }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filter strip (same look) -->
      <div class="card">
        <div class="card-body p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3"
          >
            <h5>Employees Grid</h5>
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <div class="dropdown me-3">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  {{ designationLabel }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setDesignation(null)"
                      >All</a
                    >
                  </li>
                  <li v-for="d in designations" :key="d.id">
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setDesignation(d.id)"
                      >{{ d.name }}</a
                    >
                  </li>
                </ul>
              </div>

              <div class="dropdown">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Sort By : {{ sortLabel }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setSort('recent')"
                      >Recent Joiners</a
                    >
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      class="dropdown-item rounded-1"
                      @click="setSort('name_asc')"
                      >Ascending</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Employees Grid (cards) -->
      <div class="row">
        <div
          v-for="emp in pagedEmployees"
          :key="emp.id"
          class="col-xl-3 col-lg-4 col-md-6"
        >
          <div class="card position-relative">
            <div class="card-body">
              <div
                class="d-flex justify-content-between align-items-start mb-2"
              >
                <div class="form-check form-check-md">
                  <input class="form-check-input" type="checkbox" />
                </div>

                <div>
                  <router-link
                    :to="{
                      path: '/employee/employee-details',
                      query: { id: emp.id },
                    }"
                    class="avatar avatar-xl avatar-rounded online border p-1 border-primary rounded-circle"
                  >
                    <img
                      :src="emp.avatar_url"
                      class="img-fluid h-auto w-auto"
                      alt="img"
                    />
                  </router-link>
                </div>

                <div class="dropdown">
                  <button
                    class="btn btn-icon btn-sm rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="ti ti-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <a
                        class="dropdown-item rounded-1"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#add_employee"
                        @click="openEditModal(emp)"
                      >
                        <i class="ti ti-edit me-1"></i>Edit
                      </a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item rounded-1"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#delete_modal"
                        @click="openDeleteModal(emp)"
                      >
                        <i class="ti ti-trash me-1"></i>Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="text-center mb-3">
                <h6 class="mb-1">
                  <router-link
                    :to="{
                      path: '/employee/employee-details',
                      query: { id: emp.id },
                    }"
                  >
                    {{ emp.first_name }} {{ emp.last_name || "" }}
                  </router-link>
                </h6>
                <span class="badge badge-purple-transparent fs-10 fw-medium">
                  {{ emp.designation?.name || "—" }}
                </span>
              </div>

              <div class="row text-center">
                <div class="col-4">
                  <div class="mb-3">
                    <span class="fs-12">Projects</span>
                    <h6 class="fw-medium">{{ metrics(emp).projects }}</h6>
                  </div>
                </div>
                <div class="col-4">
                  <div class="mb-3">
                    <span class="fs-12">Done</span>
                    <h6 class="fw-medium">{{ metrics(emp).done }}</h6>
                  </div>
                </div>
                <div class="col-4">
                  <div class="mb-3">
                    <span class="fs-12">Progress</span>
                    <h6 class="fw-medium">{{ metrics(emp).progress }}</h6>
                  </div>
                </div>
              </div>

              <p class="mb-2 text-center">
                Productivity :
                <span :class="productivityClass(metrics(emp).productivity)"
                  >{{ metrics(emp).productivity }}%</span
                >
              </p>
              <div class="progress progress-xs mb-2">
                <div
                  class="progress-bar"
                  :class="progressBarClass(metrics(emp).productivity)"
                  role="progressbar"
                  :style="{ width: metrics(emp).productivity + '%' }"
                ></div>
              </div>
            </div>
            <router-link
              class="stretched-link"
              :to="{
                path: '/employee/employee-details',
                query: { id: emp.id },
              }"
            />
          </div>
        </div>

        <!-- Load More -->
        <div class="col-md-12" v-if="hasMore">
          <div class="text-center mb-4">
            <a
              href="javascript:void(0);"
              class="btn btn-primary"
              @click="loadMore"
            >
              <i class="ti ti-loader-3 me-1"></i>Load More
            </a>
          </div>
        </div>

        <!-- Empty -->
        <div class="col-12" v-if="!filteredEmployees.length">
          <div class="alert alert-info">
            No employees match the current filters.
          </div>
        </div>
      </div>
      <!-- /Employees Grid -->
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>

  <!-- 🔁 SAME MODAL WIRING AS LIST PAGE -->
  <EmployeeListModal
    ref="employeeModalRef"
    :employeeToDelete="toDeleteEmployee"
    :employee="modalEmployee"
    :employeeId="modalEmployee ? modalEmployee.employee_id : nextEmployeeId"
    @refresh="fetchEmployees"
  />
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useEmployeeStore } from "@/stores/employeeStore";
import { useDesignationStore } from "@/stores/designationStore";
import { storeToRefs } from "pinia";
import EmployeeListModal from "@/components/modal/employee-list-modal.vue";

// stores
const employeeStore = useEmployeeStore();
const designationStore = useDesignationStore();
const { employees } = storeToRefs(employeeStore);
const { designations } = storeToRefs(designationStore);

// fetch
async function fetchEmployees() {
  await employeeStore.fetchEmployees();
}
onMounted(async () => {
  if (!designations.value.length) designationStore.fetchDesignations();
  await fetchEmployees();
});

// header collapse
function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

// ---------- Filters ----------
const filter = ref({
  designationId: null,
  sort: "recent", // 'recent' | 'name_asc'
});

const designationLabel = computed(() => {
  if (!filter.value.designationId) return "Designation";
  const d = designations.value.find((x) => x.id === filter.value.designationId);
  return d ? d.name : "Designation";
});
const sortLabel = computed(() => {
  if (filter.value.sort === "name_asc") return "Name A → Z";
  if (filter.value.sort === "name_desc") return "Name Z → A";
  return "Recent Joiners";
});
function setDesignation(id) {
  filter.value.designationId = id;
}
function setSort(v) {
  filter.value.sort = v;
}

// ---------- Data view ----------
const filteredEmployees = computed(() => {
  let rows = [...(employees.value || [])];

  // Designation
  if (filter.value.designationId) {
    rows = rows.filter(
      (e) => Number(e.designation_id) === Number(filter.value.designationId)
    );
  }

  // Sort
  if (filter.value.sort === "name_asc") {
    rows.sort((a, b) =>
      (a.first_name + " " + (a.last_name || "")).localeCompare(
        b.first_name + " " + (b.last_name || "")
      )
    );
  } else {
    rows.sort(
      (a, b) =>
        new Date(b.company_doj || b.created_at || 0) -
        new Date(a.company_doj || a.created_at || 0)
    );
  }

  return rows;
});

// ---------- Stats (dynamic) ----------
const stats = computed(() => {
  const rows = filteredEmployees.value;
  const total = rows.length;
  const active = rows.filter(
    (r) => (r.status || "").toLowerCase() === "active"
  ).length;
  const inactive = rows.filter(
    (r) => (r.status || "").toLowerCase() === "inactive"
  ).length;

  const now = new Date();
  const from = new Date(now.getTime() - 29 * 24 * 3600 * 1000).getTime();
  const to = now.getTime();
  const newJoiners = rows.filter((r) => {
    const ts = r.company_doj ? new Date(r.company_doj).getTime() : 0;
    return ts >= from && ts <= to;
  }).length;

  return {
    total,
    active,
    inactive,
    newJoiners,
    deltaTotal: "+0%",
    deltaActive: "+0%",
    deltaInactive: "+0%",
    deltaNewJoiners: "+0%",
  };
});

// ---------- Card metrics placeholders ----------
function metrics(e) {
  const seed = Number(e.id || 1);
  const projects = (seed % 40) + 5;
  const done = Math.max(0, Math.min(projects, seed % projects));
  const progress = Math.max(0, projects - done);
  const productivity = Math.min(
    100,
    Math.max(5, Math.round((done / projects) * 100))
  );
  return { projects, done, progress, productivity };
}
function productivityClass(val) {
  if (val >= 80) return "text-success";
  if (val >= 50) return "text-purple";
  if (val >= 30) return "text-warning";
  return "text-danger";
}
function progressBarClass(val) {
  if (val >= 80) return "bg-success";
  if (val >= 50) return "bg-purple";
  if (val >= 30) return "bg-warning";
  return "bg-danger";
}

// ---------- Pagination (Load More) ----------
const pageSize = ref(12);
const currentCount = ref(12);
const pagedEmployees = computed(() =>
  filteredEmployees.value.slice(0, currentCount.value)
);
const hasMore = computed(
  () => currentCount.value < filteredEmployees.value.length
);
function loadMore() {
  currentCount.value = Math.min(
    filteredEmployees.value.length,
    currentCount.value + pageSize.value
  );
}

// ---------- Add / Edit / Delete (same as list) ----------
const modalEmployee = ref(null);
const employeeModalRef = ref(null);
const toDeleteEmployee = ref(null);

const nextEmployeeId = computed(() => {
  if (!employees.value.length) return "EMP-0001";
  const ids = employees.value
    .map((e) => e.employee_id)
    .filter(Boolean)
    .map((id) => parseInt(String(id).replace(/[^\d]/g, ""), 10));
  const nextNum = Math.max(...ids, 0) + 1;
  return `EMP-${nextNum.toString().padStart(4, "0")}`;
});

function openAddModal() {
  modalEmployee.value = null; // create mode
}
function openEditModal(emp) {
  modalEmployee.value = emp; // edit mode, pass raw employee
}
function openDeleteModal(emp) {
  toDeleteEmployee.value = emp;
}

// ---------- Export (filtered) ----------
function exportCSV() {
  const rows = [
    [
      "Emp ID",
      "Name",
      "Email",
      "Phone",
      "Designation",
      "Joining Date",
      "Status",
    ],
    ...filteredEmployees.value.map((e) => [
      e.employee_id,
      `${e.first_name} ${e.last_name || ""}`.trim(),
      e.email || "",
      e.phone || "",
      e.designation?.name || "",
      e.company_doj ? new Date(e.company_doj).toISOString().slice(0, 10) : "",
      e.status || "",
    ]),
  ];
  const csv = rows
    .map((r) =>
      r
        .map((v) => {
          const s = String(v ?? "");
          return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
        })
        .join(",")
    )
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `employees_grid_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
</script>


<style scoped>
/* Put this in the component's <style> (scoped or global) */
.card .stretched-link { z-index: 1; }          /* default is 1 anyway, but explicit is nice */
.card .dropdown,
.card .dropdown * ,
.card .btn,
.card .form-check {
  position: relative;
  z-index: 2;           /* sit above the stretched link */
}

</style>

